import memoize from 'lodash.memoize';
import filterHtmlTags from './filterHtmlTags';
import normalizeSingleLanguageProperty from './normalizeSingleLanguageProperty';

var normalizeLanguageProperty = memoize(function (property, defaultLanguage) {
  if (!property) {
    return [];
  }
  if (typeof property === 'string') {
    return [{ '@language': defaultLanguage, '@value': filterHtmlTags(property) }];
  }
  if (Array.isArray(property)) {
    return property.map(function (prop) {
      return normalizeSingleLanguageProperty(prop, defaultLanguage);
    }).reduce(function (a, b) {
      return a.concat(b);
    }, []).filter(function (e) {
      return e;
    });
  }
  return normalizeSingleLanguageProperty(property, defaultLanguage);
});

export default normalizeLanguageProperty;